import { FormControl, Stack, Typography } from "@mui/material";
import { useMutation } from "@tanstack/react-query";
import { Formik, Form as FormikForm } from "formik";
import { Lock } from "lucide-react";
import { FC } from "react";
import { useHistory } from "react-router-dom";
import * as yup from "yup";

import { updateProfilePassword } from "api/user";
import { UpdatePasswordPayloadType } from "api/user/types";
import FormikTextField from "components/forms/FormikTextField";
import UltimateButton from "components/UltimateButton";

interface IResetPasswordForm {
  token: string;
}

const ResetPasswordForm: FC<IResetPasswordForm> = ({ token }) => {
  const history = useHistory();

  const initialValues = {
    password: "",
    repeatPassword: "",
  };

  const schema = yup.object({
    password: yup.string().required(),
    repeatPassword: yup
      .string()
      .oneOf([yup.ref("password")], "Passwords must match")
      .required(),
  });

  const { mutateAsync: resetPassword, isLoading } = useMutation(
    async (values: UpdatePasswordPayloadType) => {
      const res = await updateProfilePassword(values, {
        Authorization: `Bearer ${token}`,
      });
      return res.data;
    },
  );

  const handleSubmit = async (values: UpdatePasswordPayloadType) => {
    await resetPassword(values, {
      onSuccess: () => history.push("/login"),
    });
  };

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      validationSchema={schema}
      onSubmit={handleSubmit}
    >
      <FormikForm>
        <Stack spacing={2}>
          <FormControl fullWidth>
            <Typography variant="body2" fontWeight={600} mb={0.5}>
              New Password
            </Typography>
            <FormikTextField
              name="password"
              type="password"
              placeholder="Enter new password"
            />
          </FormControl>

          <FormControl fullWidth>
            <Typography variant="body2" fontWeight={600} mb={0.5}>
              Confirm Password
            </Typography>
            <FormikTextField
              name="repeatPassword"
              type="password"
              placeholder="Repeat new password"
            />
          </FormControl>

          <UltimateButton
            type="submit"
            text="Reset Password"
            loading={isLoading}
            Icon={
              Lock as React.ComponentType<{
                size?: number;
                className?: string;
                style?: React.CSSProperties;
              }>
            }
            sx={{ mt: 1, py: 1 }}
          />
        </Stack>
      </FormikForm>
    </Formik>
  );
};

export default ResetPasswordForm;
